module.exports = __webpack_public_path__ + "img/title-container-background-end.227d289f.png";